import { ProfileInfoSection } from "./local-components/profile-info-section";
import { ProfileLogoutButton } from "./local-components/profile-logout-button";
import { ProfilePageTitle } from "./local-components/profile-page-title";

const ProfilePage = () => (
  <main className="flex min-h-0 w-full flex-1 flex-col overflow-y-auto rounded-t-xl px-8 pb-6">
    <div className="bg-neutrals-white mx-auto w-full max-w-[72.5rem] rounded-2xl px-4 py-5 md:px-6 md:py-6">
      <ProfilePageTitle />
      <ProfileInfoSection />
      <ProfileLogoutButton />
    </div>
  </main>
);

export default ProfilePage;
